import apiService from "./apiServices";

export const saveCustomer = async(formData, token) => {
    try {

        const response = await apiService('/client-customers/save', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving customer task is failed. Please try again.');
        }
  }

  export const getLocationDetailsService = async(token) => {
    try {

        const response = await apiService('/addLocation/user/locations', 'GET', null, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving customer task is failed. Please try again.');
        }
  }

    export const switchUserLocationService = async(token, id) => {
    try {

        const response = await apiService(`/userprofile/switch-location/${id}`, 'PUT', null, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving customer task is failed. Please try again.');
        }
  }

  